import React from "react";
import Footer from "components/Footer";
import PATHS from "utils/paths";
import { landingStyles } from "components/Landing/landingStyles";
import HeroBanner from "components/Marketing/Components/HeroBanner";
import { BUTTON_TAGS } from "utils/constants/ui";
import { isServer } from "utils/view";
import Button from "components/Form/fields/Button";
import { magicCheckoutStyles } from "components/Landing/MagicCheckout/magicCheckoutStyles";
import QRCodeManualEditor from "components/QRCodeManualEditor";
import { getIconForUID } from "components/FormerEditor/utils";
import { validateSchema } from "utils/validate";
import { LAZY_URL_REQUIRED_SCHEMA } from "constants/validation";
import {
  STRIPE_PAYMENT_LINK_RE,
  TEST_STRIPE_PAYMENT_LINK
} from "utils/constants/stripe";
const DownIcon = getIconForUID("downArrow");

const validateForm = async (formValues) => {
  const formUrl = formValues.url;
  const validated = await validateSchema(LAZY_URL_REQUIRED_SCHEMA, {
    url: formValues.url
  });
  let errors = {
    ...validated
  };
  if (!errors.url) {
    const isValid = STRIPE_PAYMENT_LINK_RE.test(formUrl);

    if (!isValid) {
      errors.url = "URL is not a valid Stripe payment link";
    }
  }

  return errors;
};

const ToolsQRCodeStripe = () => {
  const tryButtonProps = {
    tag: BUTTON_TAGS.LINK,
    href: PATHS.SIGNUP,
    copy: "Signup",
    classes: {
      button:
        "fw6 br2 pa3 border-box input-reset ba bg-transparent pointer f4 dib link items-center flex flex-shrink-0 cell-grow"
    }
  };

  const heroProps = {
    header: [
      {
        copy: "Convert any Stripe"
      },
      {
        copy: "payment link",
        classes: "color-primary underline"
      },
      {
        copy: "into a QR code."
      }
    ],
    subheader:
      "Design a custom QR code for any payment link. Checkout is just a scan away.",
    hideAction: true,
    paddingBottom: 0
  };

  return (
    <div className="w-100 relative">
      <div className="mw8 center">
        <HeroBanner {...heroProps} />
      </div>
      <div className="w-100 relative pb3 flex flex-column justify-center items-center">
        <div className="fw6 f4 color-primary flex flex-row items-center">
          <span>Try it</span>
          <DownIcon size={30} copy="Try it" icon="downArrow" />
        </div>
        <div className="tc dib bg-white center f5 pt2 lh-copy ph3 ph0-l">
          Enter any Stripe payment link to get started.
        </div>
      </div>
      <QRCodeManualEditor
        validate={validateForm}
        url={TEST_STRIPE_PAYMENT_LINK}
        withRedirect
      />
      <div className="w-100 before__image magic_checkout_link_bg relative">
        <div className="w-100 relative mw8 center pt5 pt1-l pb5">
          <div className="w-100 flex items-center justify-center">
            <div className="flex flex-column justify-center">
              <div className="fw6 tc dib bg-white center f3 f2-l pb2 ph3 ph0-l">
                Bring your own products and branding
              </div>
              <div className="tc dib bg-white center f5 pb2 lh-copy ph3 ph0-l">
                Connect your Stripe account to use your own products and
                branding with QR code payments.
              </div>
            </div>
          </div>
          {!isServer() && (
            <div className="flex flex-column flex-row-ns items-center justify-center pt3">
              <div className="pb3 pb0-ns">
                <Button {...tryButtonProps} />
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="mw8 center pt5-l">
        <div className="pt5 hairline-1 bt">
          <Footer />
        </div>
      </div>
      <style jsx>{landingStyles}</style>
      <style jsx>{magicCheckoutStyles}</style>
    </div>
  );
};

export default ToolsQRCodeStripe;
